import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import InboxOutlined from '@mui/icons-material/InboxOutlined';

export interface EmptyStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  actionLabel,
  onAction,
  icon,
}) => (
  <Box
    sx={{
      py: 6,
      px: 3,
      textAlign: 'center',
      border: '1px dashed',
      borderColor: 'divider',
      borderRadius: 2,
      bgcolor: 'rgba(241, 245, 249, 0.5)',
    }}
  >
    <Box sx={{ color: 'text.secondary', mb: 1.5, display: 'flex', justifyContent: 'center' }}>
      {icon ?? <InboxOutlined sx={{ fontSize: 40, opacity: 0.55 }} />}
    </Box>
    <Typography variant="h6" sx={{ mb: 0.5 }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420, mx: 'auto', mb: 2 }}>
        {description}
      </Typography>
    )}
    {actionLabel && onAction && (
      <Button variant="contained" onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </Box>
);

export default EmptyState;
